import request from "@/utils/request";

// 获取申请路线信息
export function getApplicationRoutesByApplicationId(applicationId) {
  return request({
    url: "/cloud/application/routes?applicationId=" + applicationId,
    method: "get"
  });
}

// 获取车辆可以的道路测试与示范应用测试区域路线信息
export function getVehicleApplicationAreaRoutes(vehicleId) {
  return request({
    url: "/cloud/application/area/routes?vehicleId=" + vehicleId,
    method: "get"
  });
}

